module.exports = __webpack_public_path__ + "img/shape-2@2x.5c874838.png";